/*
 * Notification that the teacher has edited assignment.
 */
import {Trans} from "@lingui/react/macro";
import * as React from "react";

import BaseToastNotification from "../components/base-toast-notification.tsx";

export default (
    props:
        | {
              contentTitle: string;
              isError: true;
              isChildAssignmentsClassroom: false;
          }
        | {
              contentTitle: string;
              studentListName: string;
              isChildAssignmentsClassroom: boolean;
              isError?: false;
          },
): React.ReactElement => (
    <BaseToastNotification isError={props.isError}>
        {props.isError && (
            <Trans>
                Oops! Looks like editing {props.contentTitle} failed. Please try
                again!
            </Trans>
        )}
        {!props.isError && props.isChildAssignmentsClassroom && (
            <Trans>
                You edited {props.contentTitle} in {props.studentListName}.
            </Trans>
        )}
        {!props.isError && !props.isChildAssignmentsClassroom && (
            <Trans>
                You edited {props.contentTitle} in your class{" "}
                {props.studentListName}.
            </Trans>
        )}
    </BaseToastNotification>
);
